<template>
  <div id="nav-bars">
    <nav id="main-nav" class="navbar navbar-expand-sm navbar-dark bg-primary">
      <router-link class="navbar-brand" to="/">LC Band Members Home</router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarColor01"
        aria-controls="navbarColor01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarColor01">
        <ul class="nav navbar-nav ml-auto">
          
          <li class="nav-item">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>
          
          <li class="nav-item">
            <router-link :to="{name: 'contact'}" class="nav-link">Contact Admin</router-link>
          </li>
          <li v-if="!user" class="nav-item">
            <router-link to="/register" class="nav-link">Create Account</router-link>
          </li>
          <li v-if="!user" class="nav-item">
            <router-link to="/login" class="nav-link">Login</router-link>
          </li>
          
        </ul>
      </div>
    </nav>

    <nav v-if="user" id="user-nav" class="navbar py-0 navbar-expand-sm navbar-dark bg-dark">
      <span class="navbar-text">Welcome User: {{user.email}}</span>

      <!-- <div class="navbar-text px-4">Uploads: {{numUploads}} / {{maxNumUploads}}</div> -->

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarColor02"
        aria-controls="navbarColor02"
        aria-expanded="false"
        aria-label="Toggle user navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarColor02">
        <ul class="nav navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a
              v-if="user"
              @click.prevent="createUserRecord"
              href
              class="nav-link"
            >TEMP: Create User Record</a>
          </li> -->
          
          <!-- <li class="nav-item">
            <router-link to="/dashboard" class="nav-link">Main Dashboard</router-link>
          </li> -->
          <li class="nav-item">
            <router-link to="/user-edit-email" class="nav-link">Edit Email</router-link>
          </li>
          <li class="nav-item">
            <a @click.prevent="logout" href class="nav-link">Logout</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import fbServices from "@/firebase/init.js";
const auth = fbServices.auth;
// const db = fbServices.db;



export default {
  data() {
    return {
      user: null,
    };
  },
  methods: {
    
    logout() {
      auth.signOut().then(() => {
        this.$router.push("login");
      });
    },
    
  //   initUploadsStats() { // Method called in created() in the auth observer; user set to this.user there.
  //     // Fetch the associated record from the 'users' collection
  //     const docRef = db.collection("users").doc(this.user.uid);
  //     docRef
  //       .get()
  //       .then(doc => {
  //         if (doc.exists) { 
          
  //           // console.log("Login: User doc fetched:", doc.data());
  //           this.numUploads = doc.data().uploads.length;
  //           this.maxNumUploads = doc.data().maxNumUploads;
  //         } else {
  //           console.log("Login: User doc fetched: Non-existent");
  //         }
  //       })
  //       .catch(err => {
  //         console.log("Login: Fetch user doc error:", err);
  //       });
  //   }
  },
  created() {
    
    auth.onAuthStateChanged(user => {
      // If user exists, then they logged in
      if(user) {
      // user.numImages = 17;
      // console.log('ON AUTH STATE CHANGE NavBar:',user);

      this.user = user;
      // this.initUploadsStats();

      // If no user, then they logged out
      } else {
        this.user = null;
        
      }
    });
  }
}
</script>
